module.exports = __webpack_public_path__ + "static/media/FacebookLog.9807d3ca.svg";